module.exports = __webpack_public_path__ + "icons/original/small/small-e3.158bc24007fc557a4756dcaaf638f81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-e3.png
// module id = E9CV
// module chunks = app